<!-- Azure AD: This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
<router-outlet *ngIf="!isIframe"></router-outlet>

<!-- 整個系統的 Loading 遮罩 -->
<div class="bpaas-progress-spinner" [class.bpaas-hidden]="!showLoadingMask">
  <p-progressSpinner strokeWidth="4" styleClass="custom-spinner"></p-progressSpinner>
</div>

<!-- 整個系統的彈出訊息顯示 -->
<p-toast position="bottom-right" [breakpoints]="{'920px': {width: '95%'}}" [preventOpenDuplicates]="true">
  <ng-template let-message pTemplate="message">
    <span [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')"
      [ngClass]="{'pi-info-circle': message.severity == 'info',
        'pi-exclamation-triangle': message.severity == 'warn',
        'pi-times-circle': message.severity == 'error',
        'pi-check' :message.severity == 'success'}">
    </span>
    <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary | translate }}</div>
        <div class="p-toast-detail">{{ message.detail | translate: message.data }}</div>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog defaultFocus="none" rejectButtonStyleClass="p-button-text"
 [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}"
 (onHide)="confirmDialogHide()">
</p-confirmDialog>

 <p-scrollTop [threshold]="10"></p-scrollTop>
